export const MANAGER = "MANAGER;"